import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getFixedQuantities, getMobilityStationQuantity } from './utils';

export const mobilitystation = [
  {
    id: 19,
    name: 'spaceTypes.mobilityStation.5workBench',
    displayOrder: 1,
    spaceTypeId: spaceTypes.mobilitystation.id,
    size: {
      [countries.US]: getSize(5.0, 5.0),
      [countries.UK]: getSize(5.0, 5.0),
      [countries.FR]: getSize(1.2, 1.2),
      [countries.EU]: getSize(1.75, 2.0),
      [countries.DE]: getSize(1.75, 2.0),
    },
    quantity: {
      [countries.US]: getMobilityStationQuantity(),
      [countries.UK]: getMobilityStationQuantity(),
      [countries.FR]: getMobilityStationQuantity(),
      [countries.EU]: getMobilityStationQuantity(),
      [countries.DE]: getMobilityStationQuantity(),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499757/insite/qa/spaces/tpupaxm2daw2oga7elph.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499757/insite/qa/spaces/tpupaxm2daw2oga7elph.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499757/insite/qa/spaces/tpupaxm2daw2oga7elph.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499757/insite/qa/spaces/tpupaxm2daw2oga7elph.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499757/insite/qa/spaces/tpupaxm2daw2oga7elph.jpg',
    },
    countries: [countries.US, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 18,
    name: 'spaceTypes.mobilityStation.workstation',
    displayOrder: 2,
    spaceTypeId: spaceTypes.mobilitystation.id,
    size: {
      [countries.US]: getSize(6.0, 6.0),
      [countries.UK]: getSize(6.0, 6.0),
      [countries.FR]: getSize(1.8288, 1.8288),
      [countries.EU]: getSize(1.5, 2.0),
      [countries.DE]: getSize(1.5, 2.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818116/insite/qa/spaces/icbbc8bxuidzr8mh4apz.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818116/insite/qa/spaces/icbbc8bxuidzr8mh4apz.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818116/insite/qa/spaces/icbbc8bxuidzr8mh4apz.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818116/insite/qa/spaces/icbbc8bxuidzr8mh4apz.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818116/insite/qa/spaces/icbbc8bxuidzr8mh4apz.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 17,
    name: 'spaceTypes.mobilityStation.office',
    displayOrder: 3,
    spaceTypeId: spaceTypes.mobilitystation.id,
    size: {
      [countries.US]: getSize(10.0, 10.0),
      [countries.UK]: getSize(10.0, 10.0),
      [countries.FR]: getSize(3.048, 3.048),
      [countries.EU]: getSize(3.5, 4.0),
      [countries.DE]: getSize(3.5, 4.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818115/insite/qa/spaces/mqtjkrf92lf5ramg1fmc.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818115/insite/qa/spaces/mqtjkrf92lf5ramg1fmc.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818115/insite/qa/spaces/mqtjkrf92lf5ramg1fmc.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818115/insite/qa/spaces/mqtjkrf92lf5ramg1fmc.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818115/insite/qa/spaces/mqtjkrf92lf5ramg1fmc.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
